/**
 * @desc 使用场景：场次监控 出价会员数|关注会员|在线会员|本机构关注会员|本机构出价会员|本机构在线会员
 *
 * 组件使用方式 ->
 * import {MembersList} from '@/components';
 * <MembersList
 *      coreParamUseComponent={id: '1'}  // 请求接口的主要参数，如id等
 *      typeUseComponent="offer"         // 查看会员数类型（同API使用时传参type）
 *      visibleUseComponent={true}       // 是否展示弹框
 * />
 *
 * API使用    ->
 * API:import { showMembersList } from '@/shared/utils';
 * showMembersList({
 *     coreParam [object]               // 请求接口的主要参数，如id等
 *     type      [enum]                 // 查看会员数类型
 *                                        'offer'：出价会员数 | 'focus'：关注会员数 | 'online' ：在线会员数
 *                                        'localOffer'：本机构出价会员数 | 'localFocus'：本机构关注会员数 | 'localOnline' ：在线会员数
 * })
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, Modal, Table } from 'antd';
import zh_CN from 'antd/es/locale/zh_CN';
import store, { dispatch } from '@@/store';
import { connect, Provider } from '@souche-f2e/muji';
import modalTitleAndTableColumns from './components/configData';
const mapStateToProps = (rootState) => ({
    _state: rootState.membersList,
});
class MembersList extends Component {
    constructor() {
        super(...arguments);
        /** 页数更改 */
        this.changePage = (e) => {
            dispatch.membersList.SET_PAGE_CURRENT(e);
            dispatch.membersList.load({});
        };
        /** @desc 渲染模态框title和remark  */
        this.renderModalTitle = (title, remark) => {
            const renderRemark = (remark) => {
                if (remark) {
                    let _r = { value: '' };
                    typeof (remark) === 'string' ? _r.value = remark : _r = remark;
                    const style = Object.assign({}, { fontSize: 14, color: '#ff0000', marginLeft: 30 }, _r.style || {});
                    return <span style={style}>{_r.value}</span>;
                }
                return null;
            };
            return (<div>
        <span>{title}</span>
        {renderRemark(remark)}
      </div>);
        };
        /** 取消模态框 */
        this.onCancel = () => {
            dispatch.membersList.hide({});
        };
        /** 模态框关闭之后 */
        this.afterClose = () => {
            dispatch.membersList.RESET_STATE();
        };
    }
    componentWillMount() {
        // 如果使用组件方式, 处理赋值或加载数据；如果不是，则不操作
        dispatch.membersList.dealUseComponent(this.props);
    }
    componentWillReceiveProps(nextProps) {
        // 如果使用组件方式, 并且visibleUseComponent变化 处理赋值或加载数据；如果不是，则不操作
        // 赋值条件容错场景： visibleUseComponent有定义但不变化的情况下操作关闭弹窗
        const { visibleUseComponent: oldV } = this.props;
        const { visibleUseComponent: newV } = nextProps;
        if (oldV !== undefined && oldV !== newV) {
            dispatch.membersList.dealUseComponent(nextProps);
        }
    }
    render() {
        const { visible, pageIndex, pageSize, totalNum, dataSource, type, tableLoading } = this.props._state;
        const { columns, title, remark } = modalTitleAndTableColumns(type);
        return (<ConfigProvider locale={zh_CN}>
        <Modal visible={visible} title={this.renderModalTitle(title, remark)} footer={null} onCancel={this.onCancel} afterClose={this.afterClose} width={1135}>
          <Table columns={columns} dataSource={dataSource} loading={tableLoading} scroll={{ y: 400 }} rowKey={row => row.key} bordered={true} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: totalNum,
            onChange: this.changePage,
            showTotal: total => `共${total}条`,
        }}/>
        </Modal>
      </ConfigProvider>);
    }
}
const MembersListConnect = connect(mapStateToProps, null, null, { forwardRef: true })(MembersList);
export default MembersListConnect;
/**
 * @desc 创建API dom
 */
let componentRef = '';
const createApiComponent = () => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(MembersListConnect, {
        ref: (ref) => {
            componentRef = ref;
        },
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
/**
 * @desc 暴露API 接口
 */
export function showMembersList({ coreParam, type }) {
    if (!componentRef) {
        createApiComponent();
    }
    dispatch.membersList.show({ coreParam, type });
}
